var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exhibition-highlights"},[_c('div',{staticClass:"image-container image-container--1x1"},[_c('a',{attrs:{"href":_vm.currentLink}},[_c('img',{attrs:{"src":_vm.currentImage,"title":_vm.currentTitle}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }